//redux
import { useSelector } from "react-redux"
import authMachine from "./machine"
const { initialState } = authMachine
//import jwtDecode from "jwt-decode"

import getaccessToken from "../../../helpers/jwt-token-access/accessToken"

export function useAuthStatus() {
  return useSelector(state => state.Login.value)
}

export function useAuthUser() {
  if (localStorage.getItem("authUser")) {
    return JSON.parse(localStorage.getItem("authUser"))
  }
  return null
}

export function useAuthIsAuthenticated() {
  return useSelector(state => {
    return state ? state.Login?.context?.isAuthenticated : false
  })
}

export function useAuthIdPersonaAuthenticated() {
  return useSelector(state => {
    return state ? state.Login?.context?.idPersonaAuthenticated : -1
  })
}

export function useAuthError() {
  return useSelector(state => {
    return state ? state.Login?.context?.authError : ""
  })
}

export function useAuthLoading() {
  return useSelector(state => state.Login.context.authLoading)
}

export function useAuthIdColegio() {
  return useSelector(state => state.Login.context.authIdColegio)
}

export function useAuthUserGmtOffset() {
  let decoded = { gmt: -6 }
  return useSelector(state => decoded?.gmt)
}

export function useAuthPermiso(rolArray) {
  const oAuthUser = useSelector(state => state.Login.context.authUser)
  return oAuthUser?.Lista_Roles?.some(rol => rolArray.includes(rol)) || false
}
